import { Controller } from "@hotwired/stimulus"

// The remove control hides while only `min` rows remain; set data-repeater-min-value="0" to allow an empty list.
export default class extends Controller {
  static targets = ["list", "template"]
  static values = { min: { type: Number, default: 1 } }

  connect() {
    this.refresh()
  }

  add() {
    if (!this.hasTemplateTarget || !this.hasListTarget) return
    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    this.listTarget.appendChild(row)
    this.refresh()
    row.querySelector("input, select, textarea")?.focus()
  }

  remove(event) {
    event.target.closest("[data-repeater-row]")?.remove()
    this.refresh()
  }

  refresh() {
    const rows = this.rows
    rows.forEach((row) => {
      const control = row.querySelector("[data-repeater-remove]")
      if (control) control.classList.toggle("hidden", rows.length <= this.minValue)

      // Identically-named rows otherwise autofill as one group in Chrome
      // (filling one fills them all). A unique, unrecognized autocomplete
      // token per field defeats that grouping.
      row.querySelectorAll("input, select, textarea").forEach((field) => {
        if (!field.dataset.repeaterAutofilled) {
          field.setAttribute("autocomplete", `off-${Math.random().toString(36).slice(2)}`)
          field.dataset.repeaterAutofilled = "true"
        }
      })
    })
  }

  get rows() {
    return Array.from(this.listTarget.querySelectorAll("[data-repeater-row]"))
  }
}
